<template>
  <div :class="['signIn-container', {collapse}]">
    <div
      class="button"
      @click="signIn"
    >
      <img
        class="signIn-logo"
        src="@assets/codeScan/code_scan_user.png"
        alt="Sign In"
      />
      <span
        class="signIn-text"
        v-if="!collapse"
      >
        {{ $t('sign-in.signInButton') }}
      </span>
    </div>
    <div
      class="mask"
      @click="closeSignIn"
      v-if="signInVisible"
    ></div>
  </div>
</template>

<script>
import { joinPaths } from '@/utils/join-path';
import EventBus from '@/lib/events';

export default {
  name: 'SignIn',
  props: {
    collapse: {
      type: Boolean,
      default: false,
    },
    isSaas: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      signInVisible: false,
    };
  },
  created() {
    EventBus.$on('signIn', this.signIn);
  },
  methods: {
    signIn() {
      this.signInVisible = this.isSaas;
      const mainContentPath = this.$router.resolve({ name: 'MainContent' }).href;

      const termsPath = this.$router.resolve({ name: 'Terms' }).href;
      const privacyPolicyPath = this.$router.resolve({ name: 'PrivacyPolicy' }).href;

      this.$auth.mountSignIn(document.querySelector('#signInContainer'), {
        fallbackRedirectUrl: joinPaths(process.env.BASE_URL, mainContentPath),
        appearance: {
          layout: {
            termsPageUrl: termsPath,
            privacyPageUrl: privacyPolicyPath,
          },
          elements: {
            footerAction: 'clerk-footerAction',
            footerPages: 'clerk-footerPages',
          },
        },
      });
    },
    closeSignIn() {
      this.signInVisible = false;
      this.$auth.unmountSignUp(document.querySelector('#signInContainer'));
    },
  },
};
</script>

<style lang="scss" scoped>
.signIn-container {
  .button {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .signIn-text {
    font-size: 14px;
    color: #2b2b2b;
    margin-left: 16px;
  }

  .signIn-logo {
    width: 24px;
    height: 24px;
  }

  &.collapse {
    margin: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 999;
  }
}
</style>
<style lang="scss">
// .clerk-footerAction {
//   display: none;
// }
</style>